import { render } from "./AppTop.vue?vue&type=template&id=074d54ba"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"
script.render = render

export default script